import { useEffect } from 'react'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { ConfigurationSteps } from './campaign-configuration/ConfigurationSteps'
import { useCampaignStore } from '@forwardflow/store'

export const CampaignConfiguration = () => {
   const { getNextStep, setCampaignConfiguration, onboardingData } =
      useOnboardingStoreV2()
   const {
      campaignConfiguration,
      setCampaignConfiguration: setTemporaryCampaignConfiguration,
   } = useCampaignStore()

   // Initialize campaign store with data from onboarding store
   useEffect(() => {
      if (onboardingData?.campaignConfiguration) {
         setTemporaryCampaignConfiguration(onboardingData.campaignConfiguration)
      }
   }, [
      onboardingData?.campaignConfiguration,
      setTemporaryCampaignConfiguration,
   ])

   return (
      <ConfigurationSteps
         onNextStep={() => {
            setCampaignConfiguration(campaignConfiguration)
            getNextStep()
         }}
      />
   )
}
